import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';

import team1 from '../../asset/images/team-1.jpg'
import team2 from '../../asset/images/team-2.jpg'
import team3 from '../../asset/images/team-3.jpg'
import team4 from '../../asset/images/team-4.jpg'
import team5 from '../../asset/images/team-5.jpg'
import team6 from '../../asset/images/team-6.jpg'
import team7 from '../../asset/images/team-7.jpg'
import team8 from '../../asset/images/team-8.jpg'
import team9 from '../../asset/images/team-9.jpg'
import team10 from '../../asset/images/team-10.jpg'
import team11 from '../../asset/images/team-11.jpg'
import team12 from '../../asset/images/team-12.jpg'
import team13 from '../../asset/images/team-13.jpg'
import team14 from '../../asset/images/team-14.jpg'
import team15 from '../../asset/images/team-15.jpg'
import team16 from '../../asset/images/team-16.jpg'
import team17 from '../../asset/images/team-17.jpg'
import team18 from '../../asset/images/team-18.jpg'
import team19 from '../../asset/images/team-19.jpg'

const AboutTeam = () => {

    const peoples = [
        {
          profile: team1,
          name: 'Calm. Sharp. A backend GURU.',
          role:'Senior Back-End Developer',
        },
        {
          profile: team3,
          name: 'Cracks jokes. Eats your snacks.',
          role:'Software Developer',
        },
        {
          profile: team2,
          name: 'Learns fast. Codes faster.',
          role:'Back-End developer',
        },
        {
          profile: team4,
          name: 'The happy bird of Backend ',
          role:'Back-End Devoloper',
        },
        {
          profile: team5,
          name: 'Silent mode: always on.',
          role:'Back-End Devoloper',
        },
        {
          profile: team6,
          name: 'Frontend brain. Always grinning.',
          role:'Senior Front-End Developer',
        },
        {
          profile: team7,
          name: 'Codes with ninja skill. Dances with wild energy.',
          role:'Front-End Developer',
        },
        {
          profile: team8,
          name: 'Quiet coder. Loud cricket fan.',
          role:'Front-End Developer',
        },
        {
          profile: team9,
          name: 'Energetic, and possibly on sugar',
          role:'Front-End Developer',
        },
        {
          profile: team10,
          name: 'Fixes bugs and moods.',
          role:'Front-End Developer',
        },
        {
          profile: team11,
          name: 'Sassy code. Snappy lines.',
          role:'Front-End Developer',
        },
        {
          profile: team12,
          name: 'Speaks less. Delivers more.',
          role:'Front-End Developer',
        },
        
        {
          profile: team14,
          name: 'Works non-stop. Deadlines still win.',
          role:'Senior IOS Developer',
        },
        {
          profile: team15,
          name: 'Stylish coder. Dances through bugs.',
          role:'Android Developer',
        },
        {
          profile: team19,
          name: 'Hyper-organized, chaos tamer.',
          role:'Manager',
        },
        {
          profile: team18,
          name: 'Designs sharp, Talks to his fish, maybe.',
          role:'UI/UX Designer',
        },
        {
          profile: team16,
          name: 'Breaks what you missed.',
          role:'Product Manager / Senior QA',
        },
        {
          profile: team17,
          name: 'Tests. Smirks. Repeats.',
          role:'Software Tester',
        },
        {
          profile: team13,
          name: 'New to code, pro at drip.',
          role:'Software Trainee',
        }
    ]
    
    function Members (props){
        return (
            <>
            <div className='col-lg-3 col-md-4 col-6 team-margin'>
                

                <div className="flip-box">
                    <div className="flip-box-inner">
                    <div className="flip-box-front team-img">
                        <img src={props.profile} alt="Paris"  />
                    </div>
                    <div className="flip-box-back">
                        <div className='team-bottom'>
                        <h4>{props.name}</h4>
                        <h6 className='mb-0'>{props.role}</h6>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            </>
        )
    }

    const [isExpanded, setIsExpanded] = useState(false);

    const visibleCount = isExpanded ? peoples.length : 12;

    const toggleExpand = () => {
    setIsExpanded(prev => !prev);
    };



    return (
        <section className='people-section'>
            <Container>
                <h5 className='service-text' data-aos="fade-right" data-aos-duration="2000">Our People</h5>

                <div className='people-margin'>
                    <div className='service-flex'>
                        <div data-aos="fade-right" data-aos-duration="2000">
                            <h4>Unlock Your Business Potential Elevate to the Next Level</h4>
                        </div>
                        
                    </div>
                </div>

                <Row className='justify-content-center'>
                    {
                        peoples.slice(0, visibleCount).map((person,index)=>(
                            <Members key={index} 
                            profile= {person.profile}
                            name= {person.name}
                            role= {person.role}
                            description= {person.description}
                            />
                        ))
                    }
                </Row>
                <div className='text-center mt-2'>
                    {peoples.length > 12 && (
                        <div className='text-center'>
                            <button className="explore-btn" onClick={toggleExpand}>
                            <span className="button-content">
                                {isExpanded ? 'Explore Less' : 'Explore More'}
                            </span>
                            </button>
                        </div>
                    )}
                </div>
            </Container>
        </section>
    )
}

export default AboutTeam
